import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-container" }

import { ref,onMounted,inject,watch, reactive } from "vue";
import { message } from "ant-design-vue";
import { TelegramClient } from "@/websocket/Client";
import { useStore } from 'vuex';

export default /*@__PURE__*/_defineComponent({
  __name: 'EditNameModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "refreshFriendList", "success"],
  setup(__props: any, { emit: __emit }) {

const client = TelegramClient.getInstance();
const tgUserNickName = ref("");
const title = ref("");
const store = useStore();
const targetIdsList = ref<any[]>([]);

 
const injectedData = inject('curSelectUser'); // 注入数据
// 表单相关
const taskForm = ref<{
  targetIds: string[];
}>({
  targetIds: [],
});

const props = __props;

const emit = __emit;

 

// 发送验证码
const handleSendCode = async () => {
 
};

onMounted(() => {
  //tgUserNickName.value = "fda";
  //targetIdsList.value = [{name:"123",nickname:"123"},{name:"121",nickname:"121"}]
   //console.log("EditNameModal onMounted");
});

const handleCancel = () => {
  console.log("handleCancel");
  emit("update:visible", false);
};


const handleOk = () => {
  console.log("handleOk");
  if(tgUserNickName.value == "")
  {
     message.error(`请输入昵称`);
     return
  }
  handleEditUser();
  //emit("refreshFriendList");
};

const handleEditUser = async () => {
  
  const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendTelegramEditUserName(
      account,
      name,
      injectedData.value.userId,
      tgUserNickName.value
    );
    if(result.message&&result.message.code == 1)
    {
      message.info(result.message.msg);
      emit("refreshFriendList");
      handleCancel();
    }
    else if(result.message)
    {
      message.error(result.message.msg);
    }
    console.log("handleEditUser");
    
};


// 监听可见性变化
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
       console.log("injectedData.userId= "+injectedData.value.userId);
       title.value = "编辑联系人(" + injectedData.value.userNick + ")";

    }
  }
);

 

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    maskClosable: false,
    title: title.value,
    style: { top: '300px'},
    onCancel: handleCancel,
    onOk: handleOk,
    width: "500px",
    okText: "确定",
    cancelText: "取消"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "昵称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: tgUserNickName.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((tgUserNickName).value = $event)),
                  placeholder: "请输入昵称"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})